module.exports = __webpack_public_path__ + "media/entities/3004-db6c8cd4.png";